import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { HelperBoxModule } from '@core/components/helpers/box/box.module';
import { CoreNotificationsModule } from '@core/components/notifications/notifications.module';
import { LayoutModalsModule } from '@core/components/layout/modals/modals.module';

// import { AppRouterModule } from '@app/router.module';

import { AppLayoutOverlappedMainComponent } from './main/main.component';
import { AppDisconnectedComponent } from './disconnected/disconnected.component';
import { AppLayoutOverlappedNotificationsComponent } from './notifications/notifications.component';

// TODO: if this not require nothing from App could go to Core
@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        HelperBoxModule,
        CoreNotificationsModule,
        LayoutModalsModule

    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        AppLayoutOverlappedMainComponent,
        AppDisconnectedComponent,
        AppLayoutOverlappedNotificationsComponent,

    ],
    exports: [
        AppLayoutOverlappedMainComponent,
        AppDisconnectedComponent,
        AppLayoutOverlappedNotificationsComponent
    ],

})
export class LayoutOverlappedModule { }
